import { render, staticRenderFns } from "./index.vue?vue&type=template&id=347ced91&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('347ced91')) {
      api.createRecord('347ced91', component.options)
    } else {
      api.reload('347ced91', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=347ced91&", function () {
      api.rerender('347ced91', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/empty/src/index.vue"
export default component.exports